export enum QuestionnaireStateEnum {
  ERROR = 'error',
  IS_FETCHING = 'isFetching',
  WORKSPACE_USER_ALLOCATIONS = 'workspaceUserAllocations',
  WORKSPACE_NETWORKS = 'workspaceNetworks',
  SURVEY_RESPONSES = 'surveyResponses',
  SURVEY_CPTS = 'surveyCPTs',
  NETWORK_CPTS = 'networkCPTs'
}
